import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';
import { Image } from 'legacyComponents/cards/styles';

export const CollectionCardImageWrapper = styled.div`
  overflow: hidden;
  transition: opacity 100ms ease-in-out;
  width: 100%;
  height: 261px;

  &:hover {
    opacity: 0.9;
  }

  ${media.xs`
    width: calc(100%);
    height: auto;
  `};
`;

export const GridImage = styled(Image)`
  width: 50%;
  height: 128px;
  object-fit: cover;
  display: inline-block;
  vertical-align: top;
`;
